import React from "react";
import ResidentDetail from "../../../stores/domainStore/pages/models/residentDetail";
import {Card, CardBody, CardHeader} from "reactstrap";
import ResidentAdminDataList from "../../organisms/residentAdminDataList/residentAdminDataList";
import ResidentAdminListHeader from "../../molecules/residentAdminListHeader/residentAdminListHeader";
import "./residentAdminTemplate.sass";
import ResidentAdminVillageMetrics from "../../organisms/residentAdminVillageMetrics/residentAdminVillageMetrics";
import {IResidentAdminDomainStore} from "../../../stores/domainStore/pages/residentAdminDomainStore";
import {IResidentAdminUiStore} from "../../../stores/uiStore/pages/residentAdminUiStore";

export interface IResidentAdminTemplateProps {
  /**
   * Indicating that the residents are loading.
   */
  isResidentAdminListLoading: boolean;

  /**
   * The callback for notices list page change event with search term.
   * If it is not provided, page change will be based on the existing data.
   */
  onSearch?: (searchTerm: string) => void;

  /**
   * An event that gets fired when the user requests to view a residents detail
   */
  showResidentsModal: (resident: ResidentDetail) => void;

  /**
   * The search term to filter residents in the table by.
   */
  searchTerm?: string;

  // Overrides let the serviced-apartment page reuse this template; default to the independent stores/namespace.
  residentAdminDomainStore?: IResidentAdminDomainStore;
  residentAdminUiStore?: IResidentAdminUiStore;
  namespace?: string;
}

const ResidentAdminTemplate: React.FC<IResidentAdminTemplateProps> = ({
  isResidentAdminListLoading,
  onSearch,
  showResidentsModal,
  searchTerm,
  residentAdminDomainStore,
  residentAdminUiStore,
  namespace
}) => {
  return (
    <div
      className="resident-admin-template"
      data-testid="residentAdminTemplate"
    >
      <Card>
        <CardHeader>
          <ResidentAdminListHeader
            isLoading={isResidentAdminListLoading}
            onSearch={onSearch}
            searchTerm={searchTerm}
            residentAdminDomainStore={residentAdminDomainStore}
            residentAdminUiStore={residentAdminUiStore}
            namespace={namespace}
          />
          <ResidentAdminVillageMetrics
            residentAdminDomainStore={residentAdminDomainStore}
            residentAdminUiStore={residentAdminUiStore}
          />
        </CardHeader>
        <CardBody>
          <ResidentAdminDataList
            showResidentModal={showResidentsModal}
            residentAdminDomainStore={residentAdminDomainStore}
            residentAdminUiStore={residentAdminUiStore}
            namespace={namespace}
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default ResidentAdminTemplate;
